<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/login" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Notifications</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="margin-top" *ngIf="!notifications.length">
    <h3 class="ion-text-center">No notifications to read</h3>
  </div>
  <div class="margin-top" *ngIf="notifications.length > 0">
    <div *ngFor="let notification of notifications" class="notification">
      <div>
        <h5>{{ notification.titulo }}</h5>
        <p>{{ notification.texto }}</p>
      </div>
      <strong class="date">{{ notification.dataEnvio | date: 'short' }}</strong>
    </div>
  </div>
</ion-content>